var map = {
	"./console.js": "./src/app/components/console.js",
	"./copy.js": "./src/app/components/copy.js",
	"./footer.js": "./src/app/components/footer.js",
	"./header.js": "./src/app/components/header.js",
	"./index.js": "./src/app/components/index.js",
	"./introduction.js": "./src/app/components/introduction.js",
	"./main.js": "./src/app/components/main.js",
	"./pre.js": "./src/app/components/pre.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/app/components sync recursive \\.js$";